import { render, staticRenderFns } from "./attribute-icon.vue?vue&type=template&id=2a0f9770&scoped=true"
import script from "./attribute-icon.vue?vue&type=script&lang=js"
export * from "./attribute-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0f9770",
  null
  
)

export default component.exports